/* unplugin-vue-components disabled */import { render } from "./F3DScaleCRender.vue?vue&type=template&id=1a76318a&scoped=true"
import script from "./F3DScaleCRender.vue?vue&type=script&lang=js"
export * from "./F3DScaleCRender.vue?vue&type=script&lang=js"

import "./F3DScaleCRender.vue?vue&type=style&index=0&id=1a76318a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a76318a"]])

export default __exports__